import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import PublicLayout from '../../../layouts/PublicLayout';
import useSEO from '../../../seo/use-seo';
import StandardPageHelmet from '../../../seo/components/StandardPageHelmet';
import {
  FineArtHeroSection,
  FineArtExperiencesSection,
  FineArtWhyMembersSection,
  FineArtJourneyCTASection
} from './FineArtGlamour';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: '#111111',
    minHeight: '100vh',
    paddingBottom: '70px',
    color: '#fff',
  }
}));

export default function FineArtGlamourPage() {
  const classes = useStyles();
  const seo = useSEO("login", {
    title: "Fine Art & Glamour | SugarCribs",
    description: "Explore curated fine art glamour, exclusive portfolios, sensual artistic photography, and masterwork collections on SugarCribs."
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div className={classes.pageContainer}>
        <FineArtHeroSection />
        <FineArtExperiencesSection />
        <FineArtWhyMembersSection />
        <FineArtJourneyCTASection />
      </div>
    </PublicLayout>
  );
}
